const styles = ({ palette, typography }) => ({
  '& $verifyDepositsLink': {
    '& i:before': {
      content: '"\u2192"',
    },
    [`@media(max-width: 360px)`]: {
      float: 'none',
      marginTop: 10,
      textAlign: 'right',
      width: '100%',
    },
    background: 'none',
    border: 'none',
    boxShadow: 'none',
    color: palette.secondary,
    cursor: 'pointer',
    float: 'right',
    fontSize: 16,
    padding: 0,
  },
  '& .pending-label': {
    color: palette.error,
    fontSize: 14,
  },
  '& > button': {
    '&$collapsed:before': {
      content: '"+"',
    },
    '&:before': {
      color: palette.secondary,
      content: '"-"',
      fontSize: 22,
      left: 0,
      position: 'absolute',
      top: -3,
    },
    ...typography.h3,
    textDecoration: 'none',
  },
  borderBottom: `1px solid ${palette.form.border}`,
  display: 'block',
  paddingBottom: 10,
  position: 'relative',
  width: '100%',
});

export default styles;
